var map = {
	"./Challenges.svg": "Etqp",
	"./CheckInPopup/Bg.svg": "2KSD",
	"./CheckInPopup/Confetti1.svg": "ir9M",
	"./CheckInPopup/Confetti2.svg": "aiVj",
	"./CheckInPopup/Scratch_Card.svg": "WV/g",
	"./Leaderboard Assest/Back.svg": "XKgB",
	"./Leaderboard Assest/Banner.svg": "t+9f",
	"./Leaderboard Assest/Cash.svg": "oJAB",
	"./Leaderboard Assest/Challanges.svg": "BSOD",
	"./Leaderboard Assest/Close.svg": "P2yH",
	"./Leaderboard Assest/History.svg": "Vb0x",
	"./Leaderboard Assest/Leaderboard.svg": "YQfs",
	"./Leaderboard Assest/Participants.svg": "pvsZ",
	"./Leaderboard Assest/Rank 1.svg": "PW7U",
	"./Leaderboard Assest/Rank 2.svg": "55ab",
	"./Leaderboard Assest/Rank 3.svg": "qAwz",
	"./Leaderboard Assest/Rank.svg": "7sTx",
	"./Leaderboard Assest/Score.svg": "EmdT",
	"./Leaderboard Assest/Time.svg": "2Fpj",
	"./Leaderboard Assest/XP.svg": "z0EC",
	"./Leaderboard Assest/info.svg": "Yjc/",
	"./Loading.svg": "XHsv",
	"./Scratch card/Reward BG.svg": "Rjul",
	"./Scratch card/SC bg.svg": "u4m6",
	"./Stamp Assests/Card.svg": "ttwo",
	"./Stamp Assests/Crackers.svg": "LBDw",
	"./Stamp Assests/Diwali Stamp Offer icon.svg": "GVu+",
	"./Stamp Assests/Diya.svg": "R5No",
	"./Stamp Assests/Gift.svg": "rtLn",
	"./Stamp Assests/Laddoo.svg": "6wXh",
	"./Stamp Assests/Lamp.svg": "Iq6c",
	"./Stamp Assests/Rangoli.svg": "Uny5",
	"./alert.png": "2LX0",
	"./arrow-down.svg": "zpNP",
	"./arrow-up.svg": "WJf4",
	"./back-light.png": "7jIq",
	"./brush.png": "dLrG",
	"./cash.svg": "NLYy",
	"./check-in.svg": "EOon",
	"./clock.svg": "4lth",
	"./close.svg": "f71c",
	"./confetti-left.svg": "sUI9",
	"./confetti-right.svg": "eZOX",
	"./congrats.svg": "yE4S",
	"./correct-answer.svg": "bA56",
	"./custom-quiz-bg.png": "rx0b",
	"./dotted-line.png": "l4Kk",
	"./dummy-banner.png": "vzmR",
	"./fonts/avenir/AvenirBold.woff": "cCTM",
	"./fonts/avenir/AvenirBold.woff2": "YcEh",
	"./fonts/avenir/AvenirLight.woff": "5bGV",
	"./fonts/avenir/AvenirLight.woff2": "VqbG",
	"./fonts/avenir/AvenirMedium.woff": "g+uD",
	"./fonts/avenir/AvenirMedium.woff2": "H4BB",
	"./fonts/avenir/AvenirSemiBold.woff": "SDfq",
	"./fonts/avenir/AvenirSemiBold.woff2": "p2YE",
	"./fonts/quiz-fonts/AvenirLTProBlack.eot": "VEmn",
	"./fonts/quiz-fonts/AvenirLTProBlack.svg": "Gqze",
	"./fonts/quiz-fonts/AvenirLTProBlack.ttf": "58mk",
	"./fonts/quiz-fonts/AvenirLTProBlack.woff": "fGKv",
	"./fonts/quiz-fonts/AvenirLTProBlack.woff2": "j8z5",
	"./fonts/quiz-fonts/AvenirLTProBook.eot": "qnXQ",
	"./fonts/quiz-fonts/AvenirLTProBook.svg": "nBH3",
	"./fonts/quiz-fonts/AvenirLTProBook.ttf": "Ox24",
	"./fonts/quiz-fonts/AvenirLTProBook.woff": "kS+k",
	"./fonts/quiz-fonts/AvenirLTProBook.woff2": "YC6m",
	"./fonts/quiz-fonts/AvenirLTProHeavy.eot": "hZ+s",
	"./fonts/quiz-fonts/AvenirLTProHeavy.svg": "y5FR",
	"./fonts/quiz-fonts/AvenirLTProHeavy.ttf": "n24R",
	"./fonts/quiz-fonts/AvenirLTProHeavy.woff": "jQl5",
	"./fonts/quiz-fonts/AvenirLTProHeavy.woff2": "v23i",
	"./fonts/quiz-fonts/AvenirLTProLight.eot": "1xHo",
	"./fonts/quiz-fonts/AvenirLTProLight.svg": "Skja",
	"./fonts/quiz-fonts/AvenirLTProLight.ttf": "4ewU",
	"./fonts/quiz-fonts/AvenirLTProLight.woff": "yT+k",
	"./fonts/quiz-fonts/AvenirLTProLight.woff2": "znU7",
	"./fonts/quiz-fonts/AvenirLTProMedium.eot": "iNrl",
	"./fonts/quiz-fonts/AvenirLTProMedium.svg": "Zvp4",
	"./fonts/quiz-fonts/AvenirLTProMedium.ttf": "TUfW",
	"./fonts/quiz-fonts/AvenirLTProMedium.woff": "Q5rX",
	"./fonts/quiz-fonts/AvenirLTProMedium.woff2": "y/SL",
	"./fonts/quiz-fonts/AvenirLTProRoman.eot": "fcTz",
	"./fonts/quiz-fonts/AvenirLTProRoman.svg": "QMwB",
	"./fonts/quiz-fonts/AvenirLTProRoman.ttf": "hzOn",
	"./fonts/quiz-fonts/AvenirLTProRoman.woff": "zng5",
	"./fonts/quiz-fonts/AvenirLTProRoman.woff2": "fpmi",
	"./fonts/quiz-fonts/AvenirLTStdBook.eot": "EOGQ",
	"./fonts/quiz-fonts/AvenirLTStdBook.svg": "8eg1",
	"./fonts/quiz-fonts/AvenirLTStdBook.ttf": "MUJq",
	"./fonts/quiz-fonts/AvenirLTStdBook.woff": "006W",
	"./fonts/quiz-fonts/AvenirLTStdBook.woff2": "Agzw",
	"./fonts/quiz-fonts/AvenirLTStdMedium.eot": "5T57",
	"./fonts/quiz-fonts/AvenirLTStdMedium.svg": "xv4r",
	"./fonts/quiz-fonts/AvenirLTStdMedium.ttf": "j+3T",
	"./fonts/quiz-fonts/AvenirLTStdMedium.woff": "7guh",
	"./fonts/quiz-fonts/AvenirLTStdMedium.woff2": "tMX+",
	"./fonts/quiz-fonts/FontAwesome.otf": "JPKf",
	"./fonts/quiz-fonts/fontawesome-webfont.eot": "zBKg",
	"./fonts/quiz-fonts/fontawesome-webfont.svg": "9G/7",
	"./fonts/quiz-fonts/fontawesome-webfont.ttf": "Owvj",
	"./fonts/quiz-fonts/fontawesome-webfont.woff": "n/uA",
	"./fonts/quiz-fonts/fontawesome-webfont.woff2": "O+dz",
	"./fonts/quiz-fonts/fonts.css": "QEjx",
	"./game-zone.svg": "Z+no",
	"./gift-box-o.svg": "zE4w",
	"./gift-box.svg": "RB8Z",
	"./gift-card-o.svg": "5QIQ",
	"./history-arrow.svg": "CbD2",
	"./history.svg": "UNRy",
	"./how-to-play-bg.png": "GMLA",
	"./info.png": "jCfu",
	"./invite.svg": "KHrB",
	"./left-arrow.svg": "cQu0",
	"./man.svg": "SlS8",
	"./medal-white.svg": "iST6",
	"./medal.svg": "Ehe8",
	"./no-data.svg": "es7N",
	"./notes.png": "8IlJ",
	"./play.svg": "Bc8N",
	"./quiz-history.svg": "+FRL",
	"./quiz-styles/bootstrap.css": "SfgN",
	"./quiz-styles/clock-regular.svg": "AxG5",
	"./quiz-styles/font-awesome.min.css": "SidB",
	"./quiz-styles/jquery.countdown.css": "LUUe",
	"./quiz-styles/quiz-styles.css": "ASMG",
	"./quiz-styles/responsive.css": "iDVW",
	"./quiz-zone.svg": "kbXU",
	"./rank-1.svg": "1dH2",
	"./rank-2.svg": "wa2n",
	"./rank-3.svg": "dykH",
	"./referral-1.svg": "Bq0q",
	"./referral.svg": "vTd1",
	"./retention-banner.svg": "7mOr",
	"./reward-o.svg": "ZiSF",
	"./reward.svg": "gRGG",
	"./right-arrow.svg": "V07J",
	"./sc-bg-empty-circle.svg": "tz8y",
	"./sc-bg.svg": "kgJE",
	"./sc-with-medal.svg": "2j5F",
	"./share.png": "az9f",
	"./share.svg": "G35t",
	"./share/copy.png": "yQTk",
	"./share/facebook.png": "68qb",
	"./share/facebook.svg": "3jnx",
	"./share/fb.png": "Og5T",
	"./share/gmail.png": "EYHO",
	"./share/instagram.svg": "k8wx",
	"./share/linkedin.png": "VWpl",
	"./share/linkedin_.png": "4iOd",
	"./share/more.svg": "6XrM",
	"./share/sms.png": "/UPn",
	"./share/telegram.png": "3bZX",
	"./share/tiw.png": "vc7/",
	"./share/twitter.png": "Cy4a",
	"./share/whatsapp.png": "4mvv",
	"./share/whatsapp.svg": "afD1",
	"./share/whatsup.png": "7RZY",
	"./target.svg": "c3H6",
	"./team.svg": "xyUi",
	"./ticket-colored.svg": "V8Cl",
	"./ticket-white.svg": "0rZ/",
	"./timer.svg": "55vm",
	"./token.svg": "j4x9",
	"./trophy.svg": "DU7G",
	"./user.svg": "gTdo",
	"./users.svg": "FocJ",
	"./vue-popper.css": "9kB+",
	"./wallet-o.svg": "pxf5",
	"./wrong-answer.svg": "+GvL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1